var _rect, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArbitrum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.730469,
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_72_1336)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0529 19.5136L18.6966 23.6631L21.1388 22.2477L17.6667 16.7749L16.0529 19.5136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3619 20.5834L23.3601 19.4493L19.5662 13.54L18.1587 15.9285L21.8212 21.8519L23.1454 21.0845C23.2753 20.979 23.3539 20.8242 23.3621 20.6572L23.3619 20.5834Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46436 21.6526L9.33436 22.7302L15.5573 12.75L14.5012 12.7222C13.6013 12.7095 12.6319 12.9434 12.187 13.6697L8.65322 19.1471L7.46436 20.9738V21.6526Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1494 12.751L16.3659 12.7611L10.0684 23.1534L12.2695 24.4208L12.8681 23.4056L19.1494 12.751Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5356 12.7365C24.5124 12.1543 24.1972 11.6214 23.7035 11.3112L16.7835 7.33154C16.2951 7.08563 15.685 7.08532 15.1958 7.33139C15.1379 7.36056 8.46625 11.23 8.46625 11.23C8.37391 11.2742 8.28497 11.327 8.20132 11.3869C7.76059 11.7027 7.49195 12.1936 7.46436 12.7329V20.9746L8.65322 19.1479L8.64283 12.7886C8.64422 12.7653 8.64714 12.7424 8.65128 12.7199C8.67817 12.5702 8.7617 12.4368 8.88748 12.3466C8.91886 12.3241 15.7045 8.3962 15.7261 8.38542C15.8856 8.30532 16.0883 8.30437 16.248 8.38293L23.0784 12.3119C23.24 12.4149 23.3413 12.5893 23.3503 12.7801V20.6577C23.342 20.8247 23.276 20.9795 23.1461 21.085L21.8219 21.8524L21.1386 22.2484L18.6964 23.6638L16.2197 25.0991C16.0863 25.1473 15.9303 25.1446 15.798 25.0908L12.8677 23.4054L12.2691 24.4207L14.9025 25.9369C14.9896 25.9864 15.0671 26.0303 15.1308 26.066C15.2294 26.1213 15.2966 26.1583 15.3203 26.1698C15.5075 26.2607 15.7768 26.3136 16.0195 26.3136C16.242 26.3136 16.4589 26.2728 16.6642 26.1924L23.858 22.0262C24.2709 21.7062 24.5138 21.2238 24.5356 20.7011V12.7365Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_1336",
    x1: 16,
    y1: 0.730469,
    x2: 16,
    y2: 32.7305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#317FCB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.e984093ae5bdd2e1f90608cf6d9da7e6.svg";
export { ForwardRef as ReactComponent };